import React, {ReactNode} from 'react';
import classNames from 'classnames';

// A fact about the item, in a neutral fill: Template, Archived, Beta.
export const Label: React.FC<{children: ReactNode; className?: string}> = ({
    children,
    className
}) => <span className={classNames('mx-label', className)}>{children}</span>;

interface TagProps {
    children: ReactNode;
    // Clicking a tag filters by it.
    onClick?: () => void;
    className?: string;
}

// A tag describes; it doesn't decorate. Neutral outline.
export const Tag: React.FC<TagProps> = ({children, onClick, className}) =>
    onClick ? (
        <button
            type="button"
            className={classNames('mx-tag', className)}
            onClick={onClick}
        >
            {children}
        </button>
    ) : (
        <span className={classNames('mx-tag', className)}>{children}</span>
    );

export type Status = 'success' | 'warning' | 'error' | 'info';

interface StatusChipProps {
    status: Status;
    children: ReactNode;
    className?: string;
}

// Status is the tint, a marker dot and words: never colour alone.
export const StatusChip: React.FC<StatusChipProps> = ({
    status,
    children,
    className
}) => (
    <span
        className={classNames('mx-status-chip', className)}
        data-status={status}
    >
        <span className="mx-status-dot" aria-hidden="true" />
        {children}
    </span>
);

// A yellow dot for something new, shown for its first month.
export const NewDot: React.FC<{label?: string; className?: string}> = ({
    label = 'New',
    className
}) => (
    <span className={classNames('mx-new', className)}>
        <span className="mx-new-dot" aria-hidden="true" />
        {label}
    </span>
);

// A count pinned to an icon (the bell), dark blue with white figures.
export const CountBadge: React.FC<{count: number; className?: string}> = ({
    count,
    className
}) =>
    count > 0 ? (
        <span className={classNames('mx-count', className)}>
            {count > 99 ? '99+' : count}
        </span>
    ) : null;
